import { render, staticRenderFns } from "./trialBalanceArchive.vue?vue&type=template&id=844fa77e"
import script from "./trialBalanceArchive.vue?vue&type=script&lang=js"
export * from "./trialBalanceArchive.vue?vue&type=script&lang=js"
import style0 from "./trialBalanceArchive.vue?vue&type=style&index=0&id=844fa77e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports